package com.mgacreative.hotelru.feature.reservation.ui.checkin

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.clickable
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material.icons.automirrored.filled.List
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.mgacreative.hotelru.shared.ui.designsystem.components.HFCard
import com.mgacreative.hotelru.shared.ui.designsystem.components.verticalScrollbar
import com.mgacreative.hotelru.feature.reservation.ui.checkin.CheckInItemData
import com.mgacreative.hotelru.domain.model.Room
import org.koin.compose.viewmodel.koinViewModel

import com.mgacreative.hotelru.domain.model.KbsNotification
import com.mgacreative.hotelru.feature.reservation.ui.kbs.KbsFormDialog

import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.coroutines.launch
import com.mgacreative.hotelru.domain.model.BlacklistedGuest
import com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n

@Composable
fun CheckInListScreen(
    onNavigate: (String) -> Unit = {},
    viewModel: CheckInViewModel = koinViewModel()
) {
    val checkIns by viewModel.checkIns.collectAsState()
    val scope = rememberCoroutineScope()
    
    var selectedCheckInForRoom by remember { mutableStateOf<CheckInItemData?>(null) }
    var blacklistedWarningGuest by remember { mutableStateOf<Pair<CheckInItemData, BlacklistedGuest>?>(null) }
    var kbsPromptItem by remember { mutableStateOf<CheckInItemData?>(null) }
    var activeKbsNotification by remember { mutableStateOf<KbsNotification?>(null) }
    
    LaunchedEffect(Unit) {
        viewModel.loadTodayCheckIns()
    }

    Scaffold(
        contentWindowInsets = WindowInsets(0, 0, 0, 0),
        topBar = { CheckInTopBar(onNavigate = onNavigate) },
        floatingActionButton = {
            // FAB removed as requested
        },
        bottomBar = { CheckInBottomNavBar(onNavigate = onNavigate) }
    ) { paddingValues ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(paddingValues)
                .background(Color(0xFFF1F5F9))
        ) {
            // Date Selector
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(Color(0xFFE2E8F0))
                    .padding(vertical = 8.dp, horizontal = 16.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                IconButton(onClick = { /* Previous Day */ }) {
                    Icon(Icons.Default.KeyboardArrowLeft, contentDescription = l10n("Previous Day"), tint = Color(0xFF1E3A8A))
                }
                Text("02/04/2026", fontWeight = FontWeight.Bold, color = Color(0xFF1E3A8A), fontSize = 16.sp)
                IconButton(onClick = { /* Next Day */ }) {
                    Icon(Icons.Default.KeyboardArrowRight, contentDescription = l10n("Next Day"), tint = Color(0xFF1E3A8A))
                }
            }
            // List of Checkins
            if (checkIns.isEmpty()) {
                Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                    Text(l10n("No guests found to check in for today."), color = Color.Gray, fontSize = 16.sp)
                }
            } else {
                Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.TopCenter) {
                    val gridState = androidx.compose.foundation.lazy.grid.rememberLazyGridState()
                    LazyVerticalGrid(
                        state = gridState,
                        columns = GridCells.Adaptive(minSize = 380.dp),
                        modifier = Modifier.fillMaxSize().widthIn(max = 1400.dp).verticalScrollbar(gridState),
                        contentPadding = PaddingValues(16.dp),
                        horizontalArrangement = Arrangement.spacedBy(16.dp),
                        verticalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        items(checkIns) { itemData ->
                            CheckInCard(
                                item = itemData,
                                onCheckInClick = { item ->
                                    scope.launch {
                                        val matchedBlacklist = viewModel.checkBlacklist(item.guestName, item.identityNo)
                                        if (matchedBlacklist != null) {
                                            blacklistedWarningGuest = Pair(item, matchedBlacklist)
                                        } else {
                                            selectedCheckInForRoom = item
                                        }
                                    }
                                },
                                onOpenKbsClick = { item ->
                                    activeKbsNotification = KbsNotification(
                                        guestType = if (item.identityNo.length == 11) "TC Vatandaşı" else "Yabancı",
                                        identityNo = item.identityNo,
                                        firstName = item.firstName.ifBlank { item.guestName.split(" ").firstOrNull() ?: "" },
                                        lastName = item.lastName.ifBlank { item.guestName.split(" ").drop(1).joinToString(" ") },
                                        birthDate = item.birthDate.ifBlank { "01.01.1990" },
                                        roomNumber = item.rooms.firstOrNull() ?: "",
                                        checkInDateTime = item.checkInDate + " 14:00",
                                        checkOutDateTime = item.checkOutDate + " 11:00"
                                    )
                                }
                            )
                        }
                    }
                }
            }
        }
        
        selectedCheckInForRoom?.let { checkInItem ->
            RoomSelectionDialog(
                item = checkInItem,
                viewModel = viewModel,
                onDismiss = { selectedCheckInForRoom = null },
                onRoomSelected = { roomId ->
                    viewModel.completeCheckIn(checkInItem.id, roomId)
                    val completedItem = checkInItem
                    selectedCheckInForRoom = null
                    kbsPromptItem = completedItem
                }
            )
        }

        blacklistedWarningGuest?.let { (checkInItem, blacklistRecord) ->
            AlertDialog(
                onDismissRequest = { blacklistedWarningGuest = null },
                containerColor = Color.White,
                shape = RoundedCornerShape(20.dp),
                icon = { Icon(Icons.Default.Block, contentDescription = null, tint = Color(0xFFDC2626), modifier = Modifier.size(36.dp)) },
                title = { Text(l10n("🚨 ATTENTION: GUEST ON BLACKLIST!"), fontWeight = FontWeight.Bold, color = Color(0xFFDC2626)) },
                text = {
                    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                        Text(
                            l10n("This guest is registered in the 'Guest Blacklist'. Check-in is BLOCKED!"),
                            fontWeight = FontWeight.Bold,
                            fontSize = 14.sp,
                            color = Color(0xFF991B1B)
                        )
                        HorizontalDivider(color = Color(0xFFFCA5A5))
                        Text("• " + l10n("Guest Name") + ": ${checkInItem.guestName}", fontSize = 13.sp, fontWeight = FontWeight.Medium)
                        if (blacklistRecord.identityNo.isNotBlank()) {
                            Text("• " + l10n("Identity / Passport No") + ": ${blacklistRecord.identityNo}", fontSize = 13.sp, fontWeight = FontWeight.Medium)
                        }
                        Text("• " + l10n("Reason for Blacklisting") + ":", fontSize = 13.sp, fontWeight = FontWeight.Bold, color = Color(0xFFDC2626))
                        Text(blacklistRecord.reason, fontSize = 13.sp, color = Color(0xFF334155), lineHeight = 18.sp)
                    }
                },
                confirmButton = {
                    Button(
                        onClick = { blacklistedWarningGuest = null },
                        colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFDC2626))
                    ) {
                        Text(l10n("I Understand, Cancel Entry"), fontWeight = FontWeight.Bold)
                    }
                }
            )
        }

        kbsPromptItem?.let { item ->
            AlertDialog(
                onDismissRequest = { kbsPromptItem = null },
                containerColor = Color.White,
                shape = RoundedCornerShape(20.dp),
                icon = { Icon(Icons.Default.Description, contentDescription = null, tint = Color(0xFF1E3A8A)) },
                title = { Text("📋 " + l10n("KBS Identity Notification"), fontWeight = FontWeight.Bold) },
                text = {
                    Text(
                        l10n("Check-in successful.") + "\n\n" + l10n("Would you like to prepare and send the KBS form for this guest?") + " (${item.guestName})",
                        fontSize = 14.sp
                    )
                },
                confirmButton = {
                    Button(
                        onClick = {
                            val promptData = item
                            kbsPromptItem = null
                            activeKbsNotification = KbsNotification(
                                guestType = if (promptData.identityNo.length == 11) "TC Vatandaşı" else "Yabancı",
                                identityNo = promptData.identityNo,
                                firstName = promptData.firstName.ifBlank { promptData.guestName.split(" ").firstOrNull() ?: "" },
                                lastName = promptData.lastName.ifBlank { promptData.guestName.split(" ").drop(1).joinToString(" ") },
                                birthDate = promptData.birthDate.ifBlank { "01.01.1990" },
                                roomNumber = promptData.rooms.firstOrNull() ?: "",
                                checkInDateTime = promptData.checkInDate + " 14:00",
                                checkOutDateTime = promptData.checkOutDate + " 11:00"
                            )
                        },
                        colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF1E3A8A))
                    ) {
                        Text(l10n("Open KBS Form"), fontWeight = FontWeight.Bold)
                    }
                },
                dismissButton = {
                    TextButton(onClick = { kbsPromptItem = null }) {
                        Text(l10n("Later"))
                    }
                }
            )
        }

        activeKbsNotification?.let { kbsData ->
            KbsFormDialog(
                initialKbs = kbsData,
                onDismiss = { activeKbsNotification = null },
                onSendKbs = { updatedKbs ->
                    activeKbsNotification = null
                }
            )
        }
    }
}

@Composable
fun CheckInTopBar(onNavigate: (String) -> Unit) {
    Surface(tonalElevation = 2.dp, shadowElevation = 2.dp) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .background(Color.White)
                .padding(horizontal = 4.dp, vertical = 2.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            IconButton(onClick = { onNavigate("DashboardScreen") }) {
                Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = l10n("Back"), tint = Color(0xFF1E3A8A))
            }
            Text(
                text = l10n("Arrivals (Check-In)"),
                fontWeight = FontWeight.Bold,
                fontSize = 18.sp,
                color = Color(0xFF1E293B),
                modifier = Modifier.weight(1f)
            )
            IconButton(onClick = { /* Help */ }) {
                Icon(Icons.Default.Info, contentDescription = l10n("Help"), tint = Color(0xFF1E3A8A))
            }
        }
    }
}

@Composable
fun CheckInCard(
    item: CheckInItemData, 
    onCheckInClick: (CheckInItemData) -> Unit = {},
    onOpenKbsClick: (CheckInItemData) -> Unit = {}
) {
    val statusColor = if (item.isCheckInComplete) Color(0xFF059669) else Color(0xFF2563EB)
    val lightStatusColor = if (item.isCheckInComplete) Color(0xFFD1FAE5) else Color(0xFFDBEAFE)

    HFCard(
        modifier = Modifier.fillMaxWidth()
    ) {
        Row(modifier = Modifier.fillMaxWidth().height(IntrinsicSize.Min)) {
            Box(
                modifier = Modifier
                    .width(4.dp)
                    .fillMaxHeight()
                    .background(statusColor)
            )
            
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(16.dp)
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Default.Person, contentDescription = l10n("Guest"), tint = Color.Gray, modifier = Modifier.size(20.dp))
                        Spacer(modifier = Modifier.width(8.dp))
                        Text(l10n(item.guestName), fontWeight = FontWeight.Bold, fontSize = 16.sp, color = Color(0xFF1E293B))
                    }
                    
                    Row(
                        modifier = Modifier
                            .clip(RoundedCornerShape(16.dp))
                            .background(Color.Transparent)
                            .border(1.dp, statusColor, RoundedCornerShape(16.dp))
                            .padding(horizontal = 10.dp, vertical = 4.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Icon(
                            imageVector = if (item.isCheckInComplete) Icons.Default.CheckCircle else Icons.Default.Info,
                            contentDescription = "Status",
                            tint = statusColor,
                            modifier = Modifier.size(16.dp)
                        )
                        Spacer(modifier = Modifier.width(4.dp))
                        Text(l10n(item.statusText), color = statusColor, fontSize = 12.sp, fontWeight = FontWeight.Medium)
                    }
                }
                
                Spacer(modifier = Modifier.height(12.dp))
                
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Default.Home, contentDescription = l10n("Rooms"), tint = Color.Gray, modifier = Modifier.size(16.dp))
                    Spacer(modifier = Modifier.width(12.dp))
                    val roomsText = item.rooms.map { l10n(it) }.joinToString(", ")
                    Text(roomsText, color = Color.DarkGray, fontSize = 14.sp)
                }
                
                Spacer(modifier = Modifier.height(8.dp))
                
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Default.DateRange, contentDescription = "Dates", tint = Color.Gray, modifier = Modifier.size(16.dp))
                    Spacer(modifier = Modifier.width(12.dp))
                    Text(item.dateRange, color = Color.Gray, fontSize = 14.sp)
                }
                
                Spacer(modifier = Modifier.height(14.dp))
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    OutlinedButton(
                        onClick = { onOpenKbsClick(item) },
                        modifier = Modifier.weight(1f),
                        shape = RoundedCornerShape(8.dp)
                    ) {
                        Icon(Icons.Default.Description, contentDescription = null, modifier = Modifier.size(16.dp), tint = Color(0xFF1E3A8A))
                        Spacer(modifier = Modifier.width(4.dp))
                        Text(l10n("KBS Form"), fontSize = 12.sp, color = Color(0xFF1E3A8A), fontWeight = FontWeight.Bold)
                    }

                    if (!item.isCheckInComplete) {
                        Button(
                            onClick = { onCheckInClick(item) },
                            modifier = Modifier.weight(1.3f),
                            colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF2563EB)),
                            shape = RoundedCornerShape(8.dp)
                        ) {
                            Text(l10n("Assign Room & Check-in"), color = Color.White, fontWeight = FontWeight.Bold, fontSize = 12.sp)
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun RoomSelectionDialog(
    item: CheckInItemData,
    viewModel: CheckInViewModel,
    onDismiss: () -> Unit,
    onRoomSelected: (String) -> Unit
) {
    var availableRooms by remember { mutableStateOf<List<AvailableRoomUI>>(emptyList()) }
    var isLoading by remember { mutableStateOf(true) }

    LaunchedEffect(item.roomType) {
        isLoading = true
        availableRooms = viewModel.getAvailableRooms(item.roomType)
        isLoading = false
    }

    androidx.compose.material3.AlertDialog(
        onDismissRequest = onDismiss,
        containerColor = Color.White,
        shape = RoundedCornerShape(20.dp),
        title = { Text(l10n("Room Selection") + " - ${item.guestName}", fontWeight = FontWeight.Bold) },
        text = {
            if (isLoading) {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    androidx.compose.material3.CircularProgressIndicator()
                }
            } else if (availableRooms.isEmpty()) {
                val message = if (item.roomType.isBlank()) l10n("No available rooms found.") else l10n("No available rooms found for type") + " ${item.roomType}."
                Text(message)
            } else {
                LazyColumn(
                    modifier = Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    items(availableRooms) { room ->
                        HFCard(
                            modifier = Modifier.fillMaxWidth().clickable { onRoomSelected(room.id) }
                        ) {
                            Row(
                                modifier = Modifier.fillMaxWidth().padding(16.dp),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text("${room.roomNumber} - ${l10n(room.roomType)} - ${l10n(room.status)} - $${room.currentPrice}", fontWeight = FontWeight.Medium, fontSize = 14.sp)
                            }
                        }
                    }
                }
            }
        },
        confirmButton = {
            androidx.compose.material3.TextButton(onClick = onDismiss) {
                Text(l10n("Cancel"))
            }
        }
    )
}

@Composable
fun CheckInBottomNavBar(onNavigate: (String) -> Unit) {
    NavigationBar(containerColor = Color.White) {
        NavigationBarItem(
            icon = { Icon(Icons.AutoMirrored.Filled.List, null) },
            label = { Text(l10n("Reservation"), fontSize = 10.sp) },
            selected = false,
            onClick = { onNavigate("NewReservationCalendarScreen") }
        )
        NavigationBarItem(
            icon = { Icon(Icons.Default.DateRange, null) },
            label = { Text(l10n("Occupancy"), fontSize = 10.sp) },
            selected = false,
            onClick = { onNavigate("ReservationCalendarScreen") }
        )
        NavigationBarItem(
            icon = { 
                Box(
                    modifier = Modifier
                        .size(42.dp)
                        .clip(androidx.compose.foundation.shape.CircleShape)
                        .background(Color(0xFFE3F2FD)),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(Icons.AutoMirrored.Filled.ArrowForward, null, tint = Color(0xFF2196F3))
                }
            },
            label = { Text(l10n("Check-in"), fontSize = 10.sp, color = Color(0xFF2196F3)) },
            selected = true,
            colors = NavigationBarItemDefaults.colors(indicatorColor = Color.Transparent),
            onClick = { onNavigate("CheckInListScreen") }
        )
        NavigationBarItem(
            icon = { Icon(Icons.Default.LocationOn, null) },
            label = { Text(l10n("In Use"), fontSize = 10.sp) },
            selected = false,
            onClick = { onNavigate("InUseRoomsScreen") }
        )
        NavigationBarItem(
            icon = { Icon(Icons.Default.Assessment, null) },
            label = { Text(l10n("Room Summary"), fontSize = 10.sp) },
            selected = false,
            onClick = { onNavigate("RoomSummaryScreen") }
        )
    }
}

